import { useQuery } from "@tanstack/react-query";
import { rawFetch } from "@/lib/api/client";
import { useApp } from "@/lib/store";

type WorkspaceRole = "owner" | "admin" | "editor" | "viewer";
type Me = {
  memberships: Array<{ workspace: string; role: WorkspaceRole }>;
  is_superuser?: boolean;
};

/** Presentation guard only; the API remains the authorization authority. */
export function useWorkspacePermissions() {
  const workspaceId = useApp((state) => state.workspaceId);
  const user = useApp((state) => state.user);
  const query = useQuery<Me>({
    queryKey: ["workspace-permissions", user?.id, workspaceId],
    queryFn: () => rawFetch<Me>("/iam/me/"),
    enabled: Boolean(user && workspaceId),
    staleTime: 30_000,
  });
  const role = query.data?.memberships.find(
    (membership) => membership.workspace === workspaceId,
  )?.role;
  const isSuperuser = Boolean(query.data?.is_superuser && user?.is_superuser);
  return {
    role,
    canEdit: isSuperuser || role === "owner" || role === "admin" || role === "editor",
    canAdmin: isSuperuser || role === "owner" || role === "admin",
    isLoading: query.isLoading,
    error: query.error,
  };
}
